import React from 'react';
import { Box, Text, useDisclosure, VStack } from '@chakra-ui/react';
import { useProfile, useTransactions } from 'hooks';
import { useTranslation } from 'localization';
import { Transaction } from 'types';

import {
  Spinner,
  TransactionDetailModal,
  TransactionListItem,
} from 'components';

const RecentTransactions = () => {
  const { t } = useTranslation('component.dashboard.recentTransactions');
  const { open, onOpen, onClose } = useDisclosure();
  const [selectedTransaction, setSelectedTransaction] =
    React.useState<Transaction | null>(null);

  const { data: profile } = useProfile();
  const { data: transactions, isLoading } = useTransactions({
    queries: {
      current: 1,
      pageSize: 7,
    },
  });

  return (
    <VStack
      w="full"
      align="stretch"
      borderTopWidth="1px"
      borderTopColor="rgba(255,255,255,0.08)"
      pt={{ base: 6, lg: 6 }}
      pb={{ base: 2, lg: 4 }}
      gap={0}
    >
      <Text
        fontSize="var(--chakra-font-sizes-2xl)"
        fontWeight="500"
        color="body"
        mb={4}
      >
        {t('title')}
      </Text>
      {isLoading && (
        <Box
          w="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Spinner />
        </Box>
      )}
      {transactions && transactions.list?.length === 0 && (
        <Text w="100%" textAlign="center" color="body2">
          {t('noTransaction')}
        </Text>
      )}
      {transactions && transactions.list?.length > 0 && (
        <Box
          w="100%"
          borderTopWidth="1px"
          borderTopColor="rgba(255,255,255,0.08)"
        >
          {transactions.list.map((transaction) => (
            <TransactionListItem
              key={transaction.id}
              transaction={transaction}
              profile={profile}
              onClick={() => {
                setSelectedTransaction(transaction);
                onOpen();
              }}
            />
          ))}
        </Box>
      )}
      {profile && selectedTransaction && (
        <TransactionDetailModal
          isOpen={open}
          onClose={() => {
            onClose();
            setSelectedTransaction(null);
          }}
          transaction={selectedTransaction}
          profile={profile}
        />
      )}
    </VStack>
  );
};
export default RecentTransactions;
